export default {
  de: {
    pigSty: 'Mast',
    article: 'Artikel',
    deliveryLock: 'Verr. Sperre',
    select: 'Artkikel auswählen',
    fetchFromTransport: 'Lade aus Einteilung',
    forwarded: 'Weitergeleiteter Artikel',
    priceCategory: 'Preiskategorie',
    testPigs: 'Testschweine',
    testPig: {
      addTitle: 'Testschwein anlegen',
      editTitle: 'Testschwein bearbeiten',
      deleteTitle: 'Testschwein löschen'
    },
    useForReport: 'In Auswertungen einbeziehen',
    deliveryAttributes: {
      netWeight: 'Nettogewicht',
      taraWeight: 'Taragewicht',
      meatMeasure: 'Fleischmaß',
      baconMeasure: 'Speckmaß',
      mfa: 'MFA',
      phValue: 'PH-Wert',
      commercialClass: 'Handelsklasse',
      quality: 'Qualität',
      species: 'Tierart',
      tattoo: 'Tattoo',
      omCo: 'Ohrmarken Code',
      notice: 'Bemerkungen'
    },
    number: 'Artikelnummer',
    code: {
      title: "Artikelformel"
    },
    base: {
      title: 'Informationen'
    },
    addition: {
      title: 'Artikel Zu- Abschlag',
      value: 'Zu- Abschlag',
      type: 'Typ'
    },
    group: {
      title: 'Artikelgruppen'
    },
    notification: {
      fetchFromTransport: {
        type: 'success',
        message: 'Daten aus Einteilung erfolgreich geladen',
        title: 'Erfolgreich geladen'
      },
      save: {
        type: 'success',
        message: 'Artikelgruppe erfolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      },
      saveAddition: {
        type: 'success',
        message: 'Zu- Abschlag erfolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      },
      saveCode: {
        type: 'success',
        message: 'Formel erfolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      },
      delete: {
        type: 'success',
        message: 'Artikelgruppe erfolgreich gelöscht',
        title: 'Erfolgreich gelöscht'
      },
      deleteArticle: {
        type: 'success',
        message: 'Arikel erfolgreich gelöscht',
        title: 'Erfolgreich gelöscht'
      },
      assignGroups: {
        type: 'success',
        message: 'Artikelgruppen erfolgreich zugewiesen',
        title: 'Zuweisung erfolgreich'
      }
    },
    deliveryProgram: {
      programs: 'Lieferprogramme',
      forwarding: 'Weiterleiten',
      articleForwarding: {
        title: 'Artikel- Weiterleitung'
      },
      notification: {
        save: {
          type: 'success',
          message: 'Lieferprogramm erfolgreich gespeichert',
          title: 'Erfolgreich gespeichert'
        },
        delete: {
          type: 'success',
          message: 'Lieferprogramm erfolgreich gelöscht',
          title: 'Erfolgreich gelöscht'
        }
      }
    },
  },
}
